export default __webpack_public_path__ + "static/32214925_1015375681954514_8316080609554333696_n-04d5550141aa82fd70c0dac9bc423846.jpg";